import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDateTime,
} from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";

const InMemoryMemberNotesHeaders = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new InMemoryHeader({
    title: "globals.title",
    type: new InMemoryString("Title"),
    version: 1,
  }),
  new InMemoryHeader({
    title: "globals.category",
    type: new InMemoryString("Category", {
      getString: (item) => i18n.t("enums." + item.Category),
    }),
    version: 1,
  }),
  new InMemoryHeader({
    title: "globals.creator",
    type: new InMemoryString("CreatedBy"), 
    version: 1,
  }),
  new InMemoryHeader({
    title: "globals.timestamp",
    type: new InMemoryDateTime("Timestamp"),
    version: 1,
  }),
  new InMemoryHeader({
    title: "components.portal.theme.left_drawer.text",
    type: new InMemoryString("Text"),
    visible: false,
    version: 1,
  }),
];

export default InMemoryMemberNotesHeaders;
